import {
	ButtonUI,
	ImageCustom,
	ProductCard,
	SkeletonImage,
	SkeletonLine,
	TagDiscount,
} from '@/components';
import MultiRangeSlider from '@/components/FilterSearch/RangeSlider';
import { SelectOptions } from '@/components/FomFileds/types';
import { TYPE_PRODUCT } from '@/constant';
import { Category, IProductItem, TypePushQuery } from '@/models';
import { IState } from '@/store/reducers/commonSlice';
import { FunnelIcon, XMarkIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import React, { useState } from 'react';
import { ViewMoreItem } from './components';
import { useCart } from '../shared/hooks';
import { QueryKey } from './constants';
import * as ListItem from './components/listItem';
import { CateogyItemType } from './enum';

interface IPreviewProductModules {
	productFilter: IProductItem[] | undefined;
	optionsSort: SelectOptions[];
	onPushQuery: TypePushQuery;
	dataCategoryTree: IState['dataCategoryTree'];
	currentQuery: ParsedUrlQuery;
	dataBrand: IState['dataBrand'];
	isValidating: boolean;
	size: number;
	categoryList: Array<Category>;
}

const PreviewProductMobileModules = React.forwardRef(
	(
		{
			productFilter,
			optionsSort,
			onPushQuery,
			dataCategoryTree,
			currentQuery,
			dataBrand,
			isValidating,
			categoryList,
			size,
		}: IPreviewProductModules,
		ref: any,
	) => {
		const router = useRouter();
		const { addCart } = useCart();
		const [isShowModalFilter, setIsShowModalFilter] = useState<boolean>(false);
		// const [isShowMoreChildrenCategory, setIsShowMoreChildrenCategory] = useState<boolean>(false);
		const [saveQuery, setSaveQuery] = useState<ParsedUrlQuery>(currentQuery);

		const { topLevelCatory, subLevelCategory, levelCategory } = React.useMemo(() => {
			const topLevelCatory: ListItem.ListCategoryItem<number>[] =
				(dataCategoryTree?.data?.data?.rows as Category[]).map((item) => {
					return {
						label: item.name,
						value: item.id,
						isCheck: Boolean(
							currentQuery[QueryKey.topCategory] &&
								Number(currentQuery[QueryKey.topCategory]) === item.id,
						),
						extraQuery: QueryKey.topCategory,
					};
				}) ?? [];

			const subLevelFilter = categoryList.filter((item) => {
				const idList = topLevelCatory.map((item) => item.value);
				return idList.includes(item.level);
			});
			const levelFilter = categoryList.filter((item) => {
				const idList = subLevelFilter.map((item) => item.id);
				return idList.includes(item.level);
			});

			const subLevelCategory: ListItem.ListCategoryItem<number>[] = subLevelFilter
				.filter((item) => {
					const result: boolean =
						currentQuery[QueryKey.topCategory] &&
						(currentQuery[QueryKey.topCategory] as string)?.length > 0
							? item.level === Number(currentQuery[QueryKey.topCategory])
							: true;

					return result;
				})
				.map((item) => {
					return {
						label: item.name,
						value: item.id,
						isCheck: Boolean(
							currentQuery[QueryKey.subCategory] &&
								Number(currentQuery[QueryKey.subCategory]) === item.id,
						),
						extraQuery: QueryKey.subCategory,
					};
				});

			const levelCategory: ListItem.ListCategoryItem<number>[] = levelFilter
				.filter((item) => {
					const result: boolean =
						currentQuery[QueryKey.subCategory] &&
						(currentQuery[QueryKey.subCategory] as string)?.length > 0
							? item.level === Number(currentQuery[QueryKey.subCategory])
							: true;

					return result;
				})
				.map((item) => {
					return {
						label: item.name,
						value: item.id,
						isCheck: Boolean(
							currentQuery[QueryKey.childCategory] &&
								Number(currentQuery[QueryKey.childCategory]) === item.id,
						),
						extraQuery: QueryKey.childCategory,
						type: CateogyItemType.Square,
					};
				});

			return {
				topLevelCatory,
				subLevelCategory,
				levelCategory,
			};
		}, [categoryList, currentQuery, dataCategoryTree?.data]);

		const RenderBadge = ({ keyQuery }: { keyQuery: keyof typeof currentQuery }) => {
			const element: any[] = [];

			if (keyQuery === QueryKey.topCategory) {
				element.push({
					key: keyQuery,
					value: dataCategoryTree?.data?.data?.rows?.find(
						(el: any) => el?.id === Number(currentQuery?.[QueryKey.topCategory]),
					)?.name,
				});
			}
			if (keyQuery === QueryKey.subCategory) {
				element.push({
					key: keyQuery,
					value: categoryList?.find(
						(el: any) => el?.id === Number(currentQuery?.[QueryKey.subCategory]),
					)?.name,
				});
			}

			return element?.map((r, i) => (
				<div className='badge badge-info gap-1' key={i}>
					<span className='uppercase ml-1 text-base-100'>{r?.value}</span>
					<XMarkIcon
						width={20}
						id={r?.key}
						className={'text-base-100 cursor-pointer'}
						onClick={() => {
							if (r?.key === QueryKey.topCategory) {
								return onPushQuery({
									[QueryKey.topCategory]: '',
									[QueryKey.subCategory]: '',
									[QueryKey.category]: '',
								});
							}
							if (r?.key === QueryKey.subCategory) {
								return onPushQuery({
									// ['CategoryId' as string]: currentQuery?.ParentId,
									[QueryKey.subCategory]: '',
									[QueryKey.category]: currentQuery[QueryKey.topCategory] as string,
								});
							}
							if (r?.key === 'category' && currentQuery?.ParentId && currentQuery?.category) {
								return onPushQuery({
									category: '',
									ParentId: '',
								});
							}
							return onPushQuery({ [r.key]: '' });
						}}
					/>
				</div>
			))[0];
		};

		return (
			<div
				className={classNames([
					'relative hide-scrollbar',
					isShowModalFilter ? 'overflow-hidden' : 'overflow-auto',
				])}
			>
				<div
					className={classNames([
						'bg-black/25 inset-0 fixed z-10',
						isShowModalFilter ? 'opacity-100 visible' : 'opacity-0 invisible',
					])}
				></div>
				<div className='flex items-center justify-between border-b border-primary'>
					<div className='p-4 flex items-center w-full justify-between'>
						<div className='text-medium uppercase font-bold'>
							{productFilter?.length ? `${productFilter?.length}` : null} sản phẩm
						</div>
						<div
							className='flex items-center gap-1'
							onClick={() => setIsShowModalFilter(!isShowModalFilter)}
						>
							<FunnelIcon width={20} />
							<span>Lọc</span>
						</div>
					</div>
				</div>
				<div className='pb-6 px-1'>
					{Object.keys(currentQuery)?.length ? (
						<span className='text-mediu flex-wrap flex gap-2 items-center font-bold mb-4 text-primary'>
							KẾT QUẢ TÌM THEO
							{Object.entries(currentQuery)?.map((k, i) => (
								<RenderBadge key={i} keyQuery={k?.[0] as any} />
							))}
						</span>
					) : null}

					<div className='relative grid grid-cols-2 md:grid-cols-4 gap-1 mt-[20px] lg:mt-[40px]'>
						{isValidating && size === 1 ? (
							[...new Array(12)]?.map((_, i) => (
								<div key={i} className='slide-product bg-base-100'>
									<div className='w-full h-full'>
										<div className='w-full pb-4 aspect-square relative overflow-hidden'>
											<SkeletonImage />
										</div>
										<div className='text-left py-4 px-5'>
											<SkeletonLine nonLineMain />
										</div>
									</div>
								</div>
							))
						) : productFilter?.length ? (
							<>
								{productFilter?.map((slideContent, index) => {
									const { images, name, variants, id } = slideContent ?? {};

									const priceSplit = variants
										.map((item) => {
											return {
												currentPrice: item.salePrice,
												split: item.revenueSplit,
											};
										})
										.sort((a, b) => a.currentPrice - b.currentPrice);

									return (
										<div key={index} ref={ref}>
											<ProductCard
												url={`/chi-tiet/${slideContent?.id}`}
												image={images?.[0] ?? ''}
												title={name}
												price={priceSplit[0]?.currentPrice}
												split={priceSplit[0] && priceSplit[0].split}
												onClick={() => addCart(id)}
											/>
										</div>
									);
								})}
								{isValidating
									? [...new Array(3)]?.map((_, i) => (
											<div key={i} className='slide-product bg-base-100'>
												<div className='w-full h-full'>
													<div className='w-full pb-4 aspect-square relative overflow-hidden'>
														<SkeletonImage />
													</div>
													<div className='text-left py-4 px-5'>
														<SkeletonLine nonLineMain />
													</div>
												</div>
											</div>
									  ))
									: null}
							</>
						) : (
							<div className='col-span-3 flex flex-col relative text-center justify-center items-center h-[calc(100vh_-_288px)]'>
								<div className='inset-0'>
									<ImageCustom
										unoptimized
										src={'static/images/icon_search_not_found.png'}
										className='!w-[200px]'
									/>
									<div className='flex flex-col'>
										<span className='font-bold text-base mt-2'>Không tìm thấy sản phẩm</span>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>

				{/* modal */}
				<div
					className={classNames([
						'bg-base-100 fixed shadow-top w-full h-full max-h-[calc(100vh_-_20%)] overflow-auto hide-scrollbar rounded-t-2xl animation-300 text-base md:text-base z-[200]',
						isShowModalFilter ? 'bottom-0' : '-bottom-full',
					])}
				>
					<div className='sticky top-0'>
						<div className='text-center bg-base-100 p-4 text-primary font-bold mb-4 text-medium'>
							Bộ Lọc
						</div>
						<XMarkIcon
							width={20}
							onClick={() => setIsShowModalFilter(!isShowModalFilter)}
							className='top-4 right-2.5 absolute transform -translate-x-0 -translate-y-0'
						/>
					</div>

					<div className='p-4'>
						<div className='flex border-b pb-4 border-[#E4E4E7] flex-col gap-1'>
							<div className='text-base font-medium text-[#71717A] mb-2'>Sắp xếp theo</div>
							{optionsSort?.length
								? optionsSort?.map((op, index) => (
										<div className='flex items-center gap-4' key={index}>
											<input
												type='radio'
												id={String(op?.value)}
												name='sort'
												value={String(op?.value)}
												defaultChecked={Boolean(
													String(currentQuery?.OrderWay) === String(op?.value),
												)}
												onChange={(event) => {
													setSaveQuery((prev) => ({
														...prev,
														OrderWay: event.target.value,
														SortColumn: 'currentPrice',
													}));
												}}
											/>
											<label
												htmlFor={String(op.value)}
												className='w-full cursor-pointer font-normal'
											>
												{op?.name}
											</label>
										</div>
								  ))
								: null}
						</div>
						<div className='flex border-b py-4 border-[#E4E4E7] flex-col gap-1'>
							<ListItem.ListCategory title='Ngành' list={topLevelCatory} />
						</div>
						<ListItem.ListCategory
							className='max-h-[228px] overflow-y-auto'
							title='Chức năng'
							list={subLevelCategory}
						/>

						<div className='pt-4'>
							<div className='text-base font-medium text-[#71717A] mb-2'>Giá(vnd)</div>
							<div className='px-2'>
								<MultiRangeSlider
									min={0}
									max={5000000}
									detroyTooltip
									defaultValues={{
										min: Number(currentQuery?.PriceFrom ?? 0),
										max: Number(currentQuery?.PriceTo ?? 5000000),
									}}
									onChange={(value) => {
										setSaveQuery((prev) => ({
											...prev,
											PriceFrom: String(value?.min),
											PriceTo: String(value?.max),
										}));
									}}
								/>
							</div>
						</div>
						<ListItem.ListCategory
							className='max-h-[228px] overflow-y-auto'
							title='Sản phẩm'
							list={levelCategory}
						/>

						<div className='flex sticky bg-base-100 bottom-0 h-fit mt-4 items-center gap-2'>
							<ButtonUI
								text='Huỷ bỏ tất cả'
								color='outline'
								className='w-full'
								onClick={() => {
									onPushQuery({}, { reload: true });
								}}
							/>
							<ButtonUI
								text='Xem kết quả'
								color='primary'
								className='w-full'
								onClick={() => {
									onPushQuery(saveQuery);
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	},
);

export default PreviewProductMobileModules;
